import { render, staticRenderFns } from "./MyDialog.vue?vue&type=template&id=ec123c06&scoped=true&"
import script from "./MyDialog.vue?vue&type=script&lang=js&"
export * from "./MyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec123c06",
  null
  
)

component.options.__file = "MyDialog.vue"
export default component.exports